var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Applicants',_vm._g(_vm._b({attrs:{"title":"Denied Applicants","subject":"Denied Applicant","hide-append-buttons":"","csv-downloadable":false},scopedSlots:_vm._u([{key:"table.item.action",fn:function(slotProps){return [_c('UndenyItemAction',_vm._g(_vm._b({},'UndenyItemAction',slotProps,false),{
        'click:undeny-item': _vm.onUndenyItem,
      }))]}}])},'Applicants',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }